export const formatNumber = (number?: number, decimalPlaces = 2): string => {
  if (!number) {
    return "-";
  }
  return number.toFixed(decimalPlaces).toString();
};

export const formatNumberWithCommas = (number: string) =>
  number.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

export const formatPercentage = (
  number?: number,
  decimalPlaces = 2,
): string => {
  if (!number) {
    return "-";
  }
  return `${(number * 100 - 100).toFixed(decimalPlaces)}%`;
};
